import type { CSSProperties, ReactNode } from "react";

const DASHBOARD_CARD_HEADER_ACTION_SLOT_SIZE_PX = 26;

type DashboardCardHeaderProps = {
  children: ReactNode;
  testId: string;
  className?: string;
  contentClassName?: string;
  actions?: ReactNode;
  style?: CSSProperties;
};

export const DashboardCardHeader = ({
  children,
  testId,
  className,
  contentClassName,
  actions,
  style,
}: DashboardCardHeaderProps) => {
  const rootClassName = [
    "flex min-w-0 flex-row items-center justify-start gap-3 overflow-hidden p-[14px] text-left",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  const headerContentClassName = [
    "flex min-w-0 flex-1 flex-row items-center justify-start gap-3 overflow-hidden",
    contentClassName,
  ]
    .filter(Boolean)
    .join(" ");
  const actionSlotTestId = `${testId}-action-slot`;
  const actionPlaceholderTestId = `${testId}-action-placeholder`;

  return (
    <div
      className={rootClassName}
      data-testid={testId}
      style={{
        paddingTop: "8px",
        paddingBottom: "8px",
        ...style,
      }}
    >
      <div className={headerContentClassName}>{children}</div>
      <div
        className="flex shrink-0 items-center justify-end"
        data-testid={actionSlotTestId}
      >
        {actions ?? (
          <div
            aria-hidden="true"
            data-testid={actionPlaceholderTestId}
            style={{
              width: `${DASHBOARD_CARD_HEADER_ACTION_SLOT_SIZE_PX}px`,
              height: `${DASHBOARD_CARD_HEADER_ACTION_SLOT_SIZE_PX}px`,
            }}
          />
        )}
      </div>
    </div>
  );
};
